<script lang="ts">
  import { defineComponent } from 'vue';
  import StationFullscreenLoader from '@/components/general/StationFullscreenLoader.vue';
  import { getMobileAppData, userData } from '@/helpers/utils';
  import InAppNotificationWrapper from '@/components/ui/notifications/InAppNotificationWrapper.vue';
  import { AvailableLocale, StoreMutations } from '@/helpers/enums';
  import StatusPopupWithContentWrapper from '@/components/ui/popups/StatusPopupWithContentWrapper.vue';
  import Clarity from '@microsoft/clarity';
  import { ClarityMainEventName } from '@/helpers/constants';

  export default defineComponent({
    components: {
      StatusPopupWithContentWrapper,
      InAppNotificationWrapper,
      StationFullscreenLoader,
    },
    computed: {
      appError(): string | null {
        return this.$store.state.appError;
      },
    },
    mounted(): void {
      if (userData.data?.facility) {
        const mobileAppData = getMobileAppData();
        Clarity.identify(String(userData.data.id));
        Clarity.setTag('user_id', String(userData.data.id));
        Clarity.setTag('facility', String(userData.data.facility?.shortCode));
        Clarity.setTag('mobile_version', String(mobileAppData?.version));
        Clarity.setTag('mobile_build', String(mobileAppData?.build));
      }
      // Initial event
      Clarity.event(ClarityMainEventName);

      // Set app locale
      const userLocale = userData?.data?.locale || AvailableLocale.en;
      this.$i18n.locale = userLocale;
    },
    methods: {
      onErrorPopupHide(): void {
        this.$store.commit(StoreMutations.resetAppError);
      },
      onNotificationHide(id: string): void {
        this.$store.commit(StoreMutations.hideNotification, id);
      },
    },
  });
</script>

<template>
  <div class="container-wrapper">
    <Teleport to="body">
      <TransitionGroup v-if="!$store.state.loader" name="notification">
        <InAppNotificationWrapper
          v-for="notification in $store.state.notifications"
          :key="notification.id"
          :notification="notification"
          @hide="onNotificationHide"
        />
      </TransitionGroup>
      <StatusPopupWithContentWrapper
        :confirmation-button-text="$t('common.retry')"
        :content="appError"
        :popup-status="$enums.StatusPopupTypes.error"
        :show-popup="!!appError"
        :subtitle="$t('common.app_error')"
        @confirm="onErrorPopupHide"
      />
    </Teleport>
    <Transition name="fade">
      <StationFullscreenLoader v-if="$store.state.loader" />
    </Transition>
    <RouterView />
  </div>
</template>

<style lang="scss">
  .container-wrapper {
    height: 100%;
    width: 100%;

    .layout--wrapper {
      background-color: $white;
    }
  }
</style>
